// extracted by mini-css-extract-plugin
module.exports = {"badge":"StatusBadge_badge__Y287R","draft":"StatusBadge_draft__aPZDE","live":"StatusBadge_live__Px4kT","stopped":"StatusBadge_stopped__BnDN_","expired":"StatusBadge_expired__9Qo5D"};